import img from '../img/tarot.jpg';

const MyTarotReadings = () => {
    return (
    <article>
    <a href="https://mytarotreadings.vercel.app/" target="_blank" rel="noopener noreferrer"> <img  class="screenshot" src={img} alt="my tarot readings screenshot" /></a>
        <div className="side">
            <a href="https://mytarotreadings.vercel.app/" target="_blank" rel="noopener noreferrer"><h2>My Tarot Readings</h2></a>
            <p>My Tarot Readings is an app built with the MERN stack (MongoDB, Express, React, Node). Practitioners can log in, create readings, and track their progress over time. Future enhancements expected to include an AI called Mystic Dragon that can help with interpretations and do readings as well.</p>
            <div className="hrefs">
                <a href="https://mytarotreadings.vercel.app/" target="_blank" rel="noopener noreferrer">View website</a>
                <a href="https://github.com/chileweb76/my-tarot-readings" target="_blank" rel="noopener noreferrer">View code</a>
            </div>          
        </div>
    </article>
    )
}

export default MyTarotReadings;